<template>
  <nav class="z-50 bg-white shadow dark:bg-gray-700">
    <div class="container px-6 py-4 mx-auto">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex items-center justify-between">
          <div class="text-xl font-semibold text-gray-700">
            <a class="text-2xl font-bold text-gray-800 dark:text-white lg:text-3xl hover:text-gray-700 dark:hover:text-gray-300" href="#">LINK<span class="text-red-400 dark:text-white">→QUICK</span></a>
          </div>
          <!-- Mobile menu button -->
          <div class="flex md:hidden">
            <button @click="showHideMenu" type="button" class="text-gray-500 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 focus:outline-none focus:text-gray-600 dark:focus:text-gray-400" aria-label="toggle menu">
              <svg viewBox="0 0 24 24" class="w-6 h-6 fill-current">
                <path fill-rule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Mobile Menu open: "block", Menu closed: "hidden" -->
        <div class="flex-1 md:flex md:items-center md:justify-end" :class="[!isShow ? 'hidden' : '']">
          <div class="flex flex-col -mx-4 md:flex-row md:items-center md:mx-8">
            <a href="#" class="px-2 py-1 mx-2 mt-2 text-sm font-semibold text-red-700 transition-colors rounded-md md:mt-0 dark:text-gray-200 hover:bg-red-600 hover:text-white dark:hover:bg-gray-600">Feature</a>
            <a href="#" class="px-2 py-1 mx-2 mt-2 text-sm font-semibold text-red-700 transition-colors duration-200 transform rounded-md md:mt-0 dark:text-gray-200 hover:bg-red-600 hover:text-white dark:hover:bg-gray-600">Pricing</a>
            <a href="#" class="px-2 py-1 mx-2 mt-2 text-sm font-semibold text-red-700 transition-colors duration-200 transform rounded-md md:mt-0 dark:text-gray-200 hover:bg-red-600 hover:text-white dark:hover:bg-gray-600">Contact us</a>
            <a href="#" class="px-2 py-1 mx-2 mt-2 text-sm font-semibold text-red-700 transition-colors duration-200 transform rounded-md md:mt-0 dark:text-gray-200 hover:bg-red-600 hover:text-white dark:hover:bg-gray-600">Document</a>
          </div>

          <div class="flex items-center mt-4 md:mt-0">
            <!-- Toggle Dark and Light -->
            <label for="toogle" class="flex items-center cursor-pointer mx-4">
              <!-- toggle -->
              <div class="relative">
                <!-- input -->
                <input id="toogle" type="checkbox" class="sr-only" />
                <!-- line -->
                <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                <!-- dot -->
                <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
              </div>
            </label>

            <button type="button" class="flex items-center focus:outline-none" aria-label="toggle profile dropdown">
              <div class="w-8 h-8 overflow-hidden border-2 border-gray-400 rounded-full">
                <img src="https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=334&q=80" class="object-cover w-full h-full" alt="avatar" />
              </div>

              <h3 class="mx-2 text-sm font-medium text-gray-700 dark:text-gray-200 md:hidden">Wang Truong</h3>
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
    };
  },
  mounted() {
    const checkbox = document.querySelector("#toogle");
    const html = document.querySelector("html");
    // Whenever the user explicitly chooses light mode
    if (localStorage.theme == "light") {
      checkbox.checked = false;
    } else if (localStorage.theme == "dark") {
      checkbox.checked = true;
    }
    const toggleDarkMode = () => {
      checkbox.checked ? html.classList.add("dark") : html.classList.remove("dark");
      checkbox.checked ? (localStorage.theme = "dark") : (localStorage.theme = "light");
    };
    toggleDarkMode();
    checkbox.addEventListener("click", toggleDarkMode);
  },
  methods: {
    showHideMenu() {
      this.isShow = !this.isShow;
    },
  },
};
</script>
<style scoped>
/* Toggle A */
input:checked ~ .dot {
  transform: translateX(100%);
  background-color: #74ff99;
}
</style>